var utils = require("../utils");
var config = require("../config");

var performanceLogger = {};
var name = "performanceLogger";
var type = 3;

//私有函数
//发送到服务器
function sendPerformance() {
    if(window.performance && window.performance.timing && window.performance.timing.toJSON){
        // var timing = window.performance.timing.toJSON();
        /*---------------------------------统计页面性能-----------------------------------*/
        var timing = performance.timing
        // DNS解析时间
        var dnsTime = timing.domainLookupEnd-timing.domainLookupStart || 0
        //TCP建立时间
        var tcpTime = timing.connectEnd-timing.connectStart || 0
        // 白屏时间
        var whiteTime = timing.responseStart-timing.navigationStart || 0
        //dom加载完成时间*
        var domTime = timing.domContentLoadedEventEnd-timing.navigationStart || 0
        //页面onload时间*
        var loadTime = timing.loadEventEnd - timing.navigationStart || 0

        if(loadTime<config.page_load_slow_time){
            return
        }

        // 页面准备时间
        var readyTime = timing.fetchStart-timing.navigationStart || 0
        // 页面重定向时间
        var redirectTime = timing.redirectEnd - timing.redirectStart || 0
        // unload时间
        var unloadTime = timing.unloadEventEnd - timing.unloadEventStart || 0
        //request请求耗时
        var requestTime = timing.responseEnd - timing.requestStart || 0
        //页面解析dom耗时
        var analysisDomTime = timing.domCompvare - timing.domInteractive || 0
        
        dnsTime=dnsTime<0?0:dnsTime
        tcpTime=tcpTime<0?0:tcpTime
        whiteTime=whiteTime<0?0:whiteTime
        domTime=domTime<0?0:domTime
        loadTime=loadTime<0?0:loadTime
        readyTime=readyTime<0?0:readyTime
        redirectTime=redirectTime<0?0:redirectTime
        unloadTime=unloadTime<0?0:unloadTime
        requestTime=requestTime<0?0:requestTime
        analysisDomTime=analysisDomTime<0?0:analysisDomTime

        var param={
            dnsTime:dnsTime,
            tcpTime:tcpTime,
            whiteTime:whiteTime,
            domTime:domTime,
            loadTime:loadTime,
            readyTime:readyTime,
            redirectTime:redirectTime,
            unloadTime:unloadTime,
            requestTime:requestTime,
            analysisDomTime:analysisDomTime
            // resourceTime:resourceTime,
            // preUrl:preUrl
        }
        window.xlog_performance = param
        param['xt']=type
        utils.requestRemote(param)
    }
}

/**
 * 手动导出开启函数
 * @return {[type]} [description]
 */
performanceLogger.launch=function(){
    if(window.performance && document.addEventListener){
        // document.addEventListener('DOMContentLoaded', function(){
        //     console.log(1)
        // }, false);
        window.addEventListener('load',function(){
            // console.log(2)
            setTimeout(sendPerformance,0)
        },false);
    }
}

module.exports = performanceLogger;


//////////////////
// WEBPACK FOOTER
// ./src/logger/performanceLogger.js
// module id = 5
// module chunks = 0 1 2